var noop = function () {};
var Rate = /** @class */function () {
  function Rate() {}
  Rate.rate = function (callback) {
    if (callback === void 0) {
      callback = noop;
    }
  };
  return Rate;
}();
export default Rate;